import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  output,
} from '@angular/core';

import { OptionalAsyncPipe } from '../../../pipes/OptionalAsync.pipe';
import { ActionService } from '../../../services/action/action.service';
import { MenuItemType } from '../../../types/menu-item.type';
import { BadgeItemType } from '../../../types/organization.type';
import { AvatarComponent } from '../../avatar/avatar.component';
import { IconComponent } from '../../icon/icon.component';

@Component({
  selector: 'evc-menu-item',
  imports: [
    NgClass,
    OptionalAsyncPipe,
    IconComponent,
    AvatarComponent,
  ],
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuItemComponent {
  #actionService = inject(ActionService);

  readonly itemClicked = output();
  readonly organizationClicked = output<BadgeItemType>();

  readonly item = input<MenuItemType>();
  readonly badgeItem = input<BadgeItemType>();
  readonly aditionalText = input<string>();
  readonly selected = input(false); // for badge items
  readonly disabled = input(false);
  readonly externalContext = input(false);

  #destroyRef = inject(DestroyRef);
  initials: string | undefined;

  handleItemClick(item: MenuItemType | undefined): void {
    if (!item || this.disabled() || item.isDisabled) return;

    this.#actionService.handleAction(item, this.#destroyRef);
    this.itemClicked.emit();
  }

  handleOrganizationClick(item: BadgeItemType): void {
    if (this.disabled()) return;

    this.organizationClicked.emit(item);
  }

  isActionURL(item: MenuItemType): boolean {
    return this.#actionService.isActionURL(item);
  }
}
